module.exports = __webpack_public_path__ + "static/media/no_invitations.cc852254.png";